import React from "react";
import PropTypes from "prop-types";
import SourceEntity from "../../models/SourceEntity";
import { pluralize } from "../../../../common/helpers/helpers";
import { varsomeHost } from "../../../../common/helpers/Urls";

function EntityOption({ entity }) {
  if (!entity) return null;
  const geneLink = `${varsomeHost}/search-results/${entity.symbol}`;

  return entity.symbol ? (
    <div className="tw-cursor-pointer">
      {entity.count?.toLocaleString() || 0}{" "}
      {pluralize(entity.count, "publication", "publications")} related to gene{" "}
      <a href={geneLink} target="_blank" rel="noreferrer">
        {entity.symbol}
      </a>
    </div>
  ) : (
    <div className="tw-cursor-pointer">
      {entity.count?.toLocaleString() || 0}{" "}
      {pluralize(entity.count, "publication", "publications")} related to this{" "}
      {entity.type}
    </div>
  );
}

EntityOption.propTypes = {
  entity: PropTypes.instanceOf(SourceEntity),
};

EntityOption.defaultProps = {
  entity: null,
};

export default EntityOption;
